import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./Main.module.css";

export default function Main({
  children,
  flex = false,
  fullwidth = false,
  margin = true,
}) {
  if (!children) return null;

  const classes = classNames({
    [`${styles.main}`]: true,
    [`${styles.flex}`]: flex,
    [`${styles.hasSidebar}`]: !fullwidth,
    [`${styles.fullwidth}`]: fullwidth,
    [`${styles.margin}`]: margin,
  });

  return <div className={classes}>{children}</div>;
}

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  flex: PropTypes.bool,
  fullwidth: PropTypes.bool,
  margin: PropTypes.bool,
};
